<form [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayoutAlign="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>Tipo organización</mat-label>
                <input matInput formControlName="tipoOrganizacion" placeholder=" Tipo organización"
                       [matAutocomplete]="tipoOrganizacion" (focusout)="cleanValuesTipoOrganizacion($event)"
                       [required]="form.get('tipoOrganizacion').errors !== null && form.get('tipoOrganizacion').errors.required">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #tipoOrganizacion="matAutocomplete" [displayWith]="displayFn"
                                  (optionSelected)="cargaOrganizacionesByTipo($event.option.value)">
                    <mat-option *ngFor="let option of tiposOrganizacionFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>Organización</mat-label>
                <input matInput formControlName="organizacion" placeholder="Unidad organizacional"
                       [matAutocomplete]="unidad" (focusout)="cleanValuesOrganizaciones($event)"
                       [required]="form.get('organizacion').errors !== null && form.get('organizacion').errors.required">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #unidad="matAutocomplete" [displayWith]="displayFn"
                                  (optionSelected)="cargarUsuarios($event.option.value)">
                    <mat-option *ngFor="let option of organizacionesFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>Usuario</mat-label>
                <input matInput formControlName="usuarioAsignado" placeholder="Usuario" [matAutocomplete]="usuario">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #usuario="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of usuariosFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>